import { put, call, takeEvery, all } from 'redux-saga/effects';
import { geocodeByAddress } from 'react-places-autocomplete';
import actions from './actions';
import { sendRequest } from '../../../../helpers/saga';
import { logger } from '../../../../helpers/logger';
import notifications from '../../../../redux/notifications/actions';
import Api from '../../../../helpers/api';

const sessionApi = new Api('orientations/:id/sessions/:id');
const orientationDetailsApi = new Api('orientations/:id');

function* loadSession({ payload }) {
  const { orientation_id, session_id } = payload;

  try {
    if (orientation_id) {
      const orientationDetailsResult = yield call(
        sendRequest,
        orientationDetailsApi.load,
        { id: orientation_id },
        notifications.REQUEST_ERROR,
      );

      if (orientationDetailsResult.data && orientationDetailsResult.data.success) {
        const {
          data: {
            success: { data: orientationDetails },
          },
        } = orientationDetailsResult;

        if (orientationDetails.address && !orientationDetails.location) {
          const location = yield call(geocodeByAddress, orientationDetails.address);
          orientationDetails.location = {
            lat: location[0].geometry.location.lat(),
            lng: location[0].geometry.location.lng(),
          };
        }
        yield put(actions.loadOrintationDetailsSuccess(orientationDetails));
      }
    }

    if (session_id && orientation_id) {
      const sessionResult = yield call(
        sendRequest,
        sessionApi.load,
        { id: [orientation_id, session_id] },
        notifications.REQUEST_ERROR,
      );

      if (sessionResult.data && sessionResult.data.success) {
        const {
          data: {
            success: { data: session },
          },
        } = sessionResult;
        yield put(actions.loadSessionSuccess(session));
      }
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD_REQUEST, loadSession)]);
}
